var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#904f89;}.b{fill:#cb6c69;}.c{fill:#95b633;}.d{fill:#bfbf3a;}.e{fill:#c1b5d2;}.f{fill:#5a9daf;}.g{fill:#fff;font-size:3px;font-family:SegoeUI, Segoe UI;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -283)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 25,
    transform: "translate(8 283)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 50,
    height: 12,
    transform: "translate(8 320)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 13,
    height: 13,
    transform: "translate(8 307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 12,
    height: 13,
    transform: "translate(21 307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13,
    height: 13,
    transform: "translate(33 307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 12,
    height: 13,
    transform: "translate(46 307)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(21 296)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(28 327)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(11 314)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(36 314)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(23 314)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(48 314)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom12);
export default __webpack_public_path__ + "static/media/random12.4a97ab94ad3ab6ebb2f0703b61e29101.svg";
export { ForwardRef as ReactComponent };